import React, { useEffect, useState } from 'react';
import { InputNumber, Card, Button } from 'antd';
import { CheckOutlined, TagFilled } from '@ant-design/icons';
import './FeatureComparisonTable.scss';
import * as ENVIRONMENT from '../../../../env.js'

const utm_source = localStorage.getItem("utm_source") || "";
const allowedKeys = [
    'Backspace',
    'Delete',
    'ArrowLeft',
    'ArrowRight',
];

const FeatureComparisonTable = ({ selectedPlan, annual, setSelectedPlan }) => {
    const subscriptions = [
        {
            for: "For anyone",
            name: "Free Trial",
            type: "free_trial",
            package_type: "free_trial_ai",
            desc: "See what's possible",
            price: "$0",
            price_monthly: "$0",
            price_time: "",
            price_details: "14-day limited trial",
            price_details_monthly: "14-day limited trial",
            discount_statement: "",
            discount_statement_monthly: "",
            switch_to_subscription: "",
            button_text: "Start your free trial",
            credits: "",
            credits_monthly: "",

        },
        {
            for: "For new sellers",
            name: "ALL3D Starter",
            type: "subscription",
            package_type: "starter_ai",
            desc: "15 images per month",
            price: "$525",
            price_monthly: "$630",
            price_time: "/month",
            price_details: "Billed annually. $35 per image",
            price_details_monthly: "Billed monthly. $42 per image",
            discount_statement: "27% the bundle price",
            discount_statement_monthly: "14% off the bundle price",
            switch_to_subscription: "",
            button_text: "Sign up for Starter",
            credits: "All 960 credits available at once. 4 credits per final image.  Unlimited 1K generations.",
            credits_monthly: "60 credits available monthly. 4 credits per final image. Unlimited 1K generations.",
        },
        {
            for: "For growing sellers",
            name: "ALL3D Growth",
            type: "subscription",
            package_type: "growth_ai",
            desc: "25 images per month",
            price: "$875",
            price_monthly: "$1,050",
            price_time: "/month",
            price_details: "Billed annually. $35 per image",
            price_details_monthly: "Billed monthly. $42 per image",
            discount_statement: "27% off the bundle price",
            discount_statement_monthly: "14% off the bundle price",
            switch_to_subscription: "",
            button_text: "Sign up for Growth",
            credits: "All 1200 credits available at once. 4 credits per final image.  Unlimited 1K generations.",
            credits_monthly: "100 credits available monthly. 4 credits per final image. Unlimited 1K generations.",
        },
        {
            for: "For pro sellers",
            name: "ALL3D Pro",
            type: "subscription",
            package_type: "pro_ai",
            desc: "50 images per month",
            credits: "12 credits per image. All 180 credits available at once.",
            price: "$1,750",
            price_monthly: "$2,100",
            price_time: "/month",
            price_details: "Billed annually. $35 per image",
            price_details_monthly: "Billed monthly. $42 per image",
            discount_statement: "27% off the bundle price",
            discount_statement_monthly: "14% off the bundle price",
            switch_to_subscription: "",
            button_text: "Sign up for Pro",
            credits: "All 2400 credits available at once. 4 credits per final image.  Unlimited 1K generations.",
            credits_monthly: "200 credits available monthly. 4 credits per final image. Unlimited 1K generations.",
        },
        {
            for: "For large teams",
            name: "ALL3D Enterprise",
            type: "subscription",
            package_type: "enterprise",
            desc: "Custom plan with 3D/AR",
            credits: "Contact us",
            price: "Let's talk",
            price_monthly: "Let's talk",
            price_details: "Schedule a time to discuss",
            price_details_monthly: "Schedule a time to discuss",
            discount_statement: "",
            discount_statement_monthly: "",
            switch_to_subscription: "",
            button_text: "Schedule a demo",
            credits: <a href="/contact-us" className='manrope f-12 w-500 lh-20 blue'>Contact us</a>,
            credits_monthly: <a href="/contact-us" className='manrope f-12 w-500 lh-20 blue'>Contact us</a>,
        }
    ];

    const basic_features_subscriptions = [
        {
            feature: "Product uploads",
            free: "3",
            starter: "Unlimited",
            growth: "Unlimited",
            pro: "Unlimited",
            enterprise: "Unlimited"
        },
        {
            feature: "Image generations",
            free: "12",
            starter: "Unlimited",
            growth: "Unlimited",
            pro: "Unlimited",
            enterprise: "Unlimited"
        },
        {
            feature: "Final 4K images",
            free: "1",
            starter: "240 annually",
            growth: "300 annually",
            pro: "600 annually",
            enterprise: "Custom"
        },
        {
            feature: "User licenses",
            free: "1",
            starter: "1",
            growth: "2",
            pro: "2",
            enterprise: "Multiple"
        },
        {
            feature: "Asset management",
            free: true,
            starter: true,
            growth: true,
            pro: true,
            enterprise: true
        },
        {
            feature: "Sharing & cloud storage",
            free: true,
            starter: true,
            growth: true,
            pro: true,
            enterprise: true
        },
        {
            feature: "Live onboarding session",
            free: false,
            starter: true,
            growth: true,
            pro: true,
            enterprise: true
        },
        {
            feature: "Managed design services",
            free: false,
            starter: false,
            growth: false,
            pro: false,
            enterprise: true
        },
        {
            feature: "Dedicated support",
            starter: false,
            growth: false,
            pro: false,
            enterprise: true
        },
        {
            feature: "Account manager",
            free: false,
            starter: false,
            growth: false,
            pro: false,
            enterprise: true
        }
    ];

    const plus_features_subscriptions = [
        {
            feature: "Resize product",
            free: true,
            starter: true,
            growth: true,
            pro: true,
            enterprise: true
        },
        {
            feature: "Magic erase",
            free: true,
            starter: true,
            growth: true,
            pro: true,
            enterprise: true
        },
        {
            feature: "Replace items",
            free: true,
            starter: true,
            growth: true,
            pro: true,
            enterprise: true
        },
        {
            feature: "Upload inspiration",
            free: true,
            starter: true,
            growth: true,
            pro: true,
            enterprise: true
        },
        {
            feature: "Upload props",
            free: true,
            starter: true,
            growth: true,
            pro: true,
            enterprise: true
        },
        {
            feature: "Photorealistic 3D models",
            free: false,
            starter: false,
            growth: false,
            pro: false,
            enterprise: true
        },
        {
            feature: "AR view in room",
            free: false,
            starter: false,
            growth: false,
            pro: false,
            enterprise: true
        },
        {
            feature: "Product silo images",
            free: false,
            starter: false,
            growth: false,
            pro: false,
            enterprise: true
        },
        {
            feature: "3D CGI images",
            free: false,
            starter: false,
            growth: false,
            pro: false,
            enterprise: true
        },
        {
            feature: "Custom scenes",
            free: false,
            starter: false,
            growth: false,
            pro: false,
            enterprise: true
        },
        {
            feature: "API integration",
            free: false,
            starter: false,
            growth: false,
            pro: false,
            enterprise: true
        },
        {
            feature: "3D configurator",
            free: false,
            starter: false,
            growth: false,
            pro: false,
            enterprise: true
        },
        {
            feature: "Project management",
            free: false,
            starter: false,
            growth: false,
            pro: false,
            enterprise: true
        },
        {
            feature: "Team collaboration",
            free: false,
            starter: false,
            growth: false,
            pro: false,
            enterprise: true
        }
    ];


    const bundles = [
        {
            for: "For anyone",
            name: "Free Trial",
            type: "bundle",
            package_type: "free_trial_ai",
            desc: "See what's possible",
            price: "$0",
            price_monthly: "$0",
            price_time: "",
            price_details: "14-day limited trial",
            price_details_monthly: "14-day limited trial",
            discount_statement: "",
            discount_statement_monthly: "",
            switch_to_subscription: "",
            button_text: "Start your free trial",
            credits: "",
            credits_monthly: "",
            min_quantity: 0,
            credit_value: 0,
        },
        {
            for: "For self-serve users",
            name: "Basic Bundle",
            type: "bundle",
            package_type: "basic_ai",
            desc: "Flexible & easy-to-manage",
            price: "$49",
            price_monthly: "$49",
            price_time: "/final 4K image",
            price_details: "5 image minimum",
            price_details_monthly: "5 image minimum",
            discount_statement: "",
            discount_statement_monthly: "",
            switch_to_subscription: "Switch to subscription – save up to 27%",
            button_text: "Buy ",
            credits: "All 20 credits available at once. 4 credits per final image. Unlimited 1K generations.",
            credits_monthly: "All credits per image. 20 credits available at once.",
            min_quantity: 5,
            credit_value: 4,
        },
        {
            for: "For low-touch sellers",
            name: "Studio Bundle",
            type: "bundle",
            package_type: "studio_bundle",
            desc: "Designer guided & managed",
            price: "$110",
            price_monthly: "$110",
            price_time: "/final 4K image",
            price_details: "45 image minimum",
            price_details_monthly: "45 image minimum",
            discount_statement: "",
            discount_statement_monthly: "",
            switch_to_subscription: "",
            button_text: "Buy",
            credits: "12 credits per image. All 540 credits available at once.",
            credits_monthly: "12 credits per image. 540 credits available at once.",
            min_quantity: 45,
            credit_value: 12,
        },
        {
            for: "For large teams",
            name: "ALL3D Enterprise",
            type: "bundle",
            package_type: "enterprise",
            desc: "Custom plan with 3D/AR",
            credits: "Contact us",
            price: "Let's talk",
            price_monthly: "Let's talk",
            price_details: "Schedule a time to discuss",
            price_details_monthly: "Schedule a time to discuss",
            discount_statement: "",
            discount_statement_monthly: "",
            switch_to_subscription: "",
            button_text: "Schedule a demo",
            credits: <a href="/contact-us" className='manrope f-12 w-500 lh-20 blue'>Contact us</a>,
            credits_monthly: <a href="/contact-us" className='manrope f-12 w-500 lh-20 blue'>Contact us</a>,
            min_quantity: 0,
            credit_value: 0,
        }
    ];

    const basic_features_bundles = [
        {
            feature: "Product uploads",
            free: "3",
            starter: "Unlimited",
            growth: "Unlimited",
            enterprise: "Unlimited"
        },
        {
            feature: "Image generations",
            free: "12",
            starter: "Unlimited",
            growth: "Unlimited",
            enterprise: "Unlimited"
        },
        {
            feature: "Final 4K images",
            free: "1",
            starter: "Custom",
            growth: "Custom",
            enterprise: "Custom"
        },
        {
            feature: "User licenses",
            free: "1",
            starter: "2",
            growth: "2",
            enterprise: "Multiple"
        },
        {
            feature: "Asset management",
            free: true,
            starter: true,
            growth: true,
            enterprise: true
        },
        {
            feature: "Sharing & cloud storage",
            free: true,
            starter: true,
            growth: true,
            enterprise: true
        },
        {
            feature: "Live onboarding session",
            free: false,
            starter: true,
            growth: true,
            enterprise: true
        },
        {
            feature: "Managed design services",
            free: false,
            starter: false,
            growth: false,
            enterprise: true
        },
        {
            feature: "Dedicated support",
            starter: false,
            growth: false,
            enterprise: true
        },
        {
            feature: "Account manager",
            free: false,
            starter: false,
            growth: false,
            enterprise: true
        }
    ];

    const plus_features_bundles = [
        {
            feature: "Resize product",
            free: true,
            starter: true,
            growth: true,
            enterprise: true
        },
        {
            feature: "Magic erase",
            free: true,
            starter: true,
            growth: true,
            enterprise: true
        },
        {
            feature: "Replace items",
            free: true,
            starter: true,
            growth: true,
            enterprise: true
        },
        {
            feature: "Upload inspiration",
            free: true,
            starter: true,
            growth: true,
            enterprise: true
        },
        {
            feature: "Upload props",
            free: true,
            starter: true,
            growth: true,
            enterprise: true
        },
        {
            feature: "Photorealistic 3D models",
            free: false,
            starter: false,
            growth: false,
            enterprise: true
        },
        {
            feature: "AR view in room",
            free: false,
            starter: false,
            growth: false,
            enterprise: true
        },
        {
            feature: "Product silo images",
            free: false,
            starter: false,
            growth: false,
            enterprise: true
        },
        {
            feature: "3D CGI images",
            free: false,
            starter: false,
            growth: false,
            enterprise: true
        },
        {
            feature: "Custom scenes",
            free: false,
            starter: false,
            growth: false,
            enterprise: true
        },
        {
            feature: "API integration",
            free: false,
            starter: false,
            growth: false,
            enterprise: true
        },
        {
            feature: "3D configurator",
            free: false,
            starter: false,
            growth: false,
            enterprise: true
        },
        {
            feature: "Project management",
            free: false,
            starter: false,
            growth: false,
            enterprise: true
        },
        {
            feature: "Team collaboration",
            free: false,
            starter: false,
            growth: false,
            enterprise: true
        }
    ];

    const [basicFeatures, setBasicFeatures] = useState(basic_features_bundles);
    const [plusFeatures, setPlusFeatures] = useState(plus_features_bundles);
    const [planType, setPlanType] = useState(bundles);
    const [quantity, setQuantity] = useState({});
    const [credits, setCredits] = useState({
        'basic_ai': 20,
        'studio_bundle': 540,
    });

    useEffect(() => {
        if (selectedPlan == 'subscriptions') {
            setBasicFeatures(basic_features_subscriptions);
            setPlusFeatures(plus_features_subscriptions);
            setPlanType(subscriptions);
        } else {
            setBasicFeatures(basic_features_bundles);
            setPlusFeatures(plus_features_bundles);
            setPlanType(bundles);
        }

    }, [selectedPlan]);

    const renderCheckmark = () => (
        <div className="checkmark">
            <CheckOutlined className="manrope f-12 w-700 white" />
        </div>
    );

    const renderValue = (value) => {
        if (typeof value === 'boolean') {
            return value ? renderCheckmark() : <div className="empty-cell"></div>;
        }
        return <span className="feature-value">{value}</span>;
    };

    const handleQuantityChange = (value, plan, credit_value) => {
        setQuantity((prev) => ({
            ...prev,
            [plan]: value,
        }));

        setCredits((prev) => ({
            ...prev,
            [plan]: (value || 0) * credit_value,
        }));
    };

    return (
        <div className="feature-comparison-table">
            <div className={`table-header ${selectedPlan == 'bundles' ? `bundles` : ''}`}>
                <div className="feature-column"></div>
                {planType.map((plan, index) => (
                    <div key={index} className={`plan-column ${['free_trial_ai'].includes(plan.package_type) ? 'top-left' : ''} ${['basic_ai', 'growth_ai'].includes(plan.package_type) ? 'blue-border' : ''} ${index == planType.length - 1 ? 'top-right' : ''}`} >
                        {['basic_ai', 'growth_ai'].includes(plan.package_type) &&
                            <div className='popular-tag-wrapper'>
                                <div className='popular-tag'>
                                    <img src={'/fire.svg'} />
                                    <span className='manrope f-10 w-700 white lh-20 mleft-4'>POPULAR</span>
                                </div>
                            </div>}
                        <Card className="plan-card" bordered={false}>
                            <div className="card-content">
                                <span className="card-subtitle manrope f-14 w-500 lh-20">{plan.for}</span>
                                <span className="card-title manrope f-20 w-700 lh-32">{plan.name}</span>
                                <div className="card-description manrope f-14 w-500 lh-22 mb-24">
                                    {plan.desc}
                                </div>
                                {selectedPlan == 'subscriptions' ?
                                    <>
                                        <div className={`card-price manrope f-26 w-700 lh-40 a-baseline mt-0 mb-0`}>
                                            <span style={{ letterSpacing: '-1px' }}>{annual ? plan.price : plan.price_monthly}</span>
                                            <div className="manrope f-14 w-400 black-085 lh-22">{plan.price_time}</div>
                                        </div>
                                        <div className={`monthly-period manrope f-14 w-400 lh-22 ${['starter_ai', 'growth_ai', 'pro_ai'].includes(plan.package_type) ? 'mb-8' : 'mb-50'}`}>{annual ? plan.price_details : plan.price_details_monthly}</div>

                                    </> :
                                    <div className={`justify-space-between align-end header-flex-no-wrap pdr-16 ${['enterprise', 'free_trial_ai', 'studio_bundle'].includes(plan.package_type) && plan.type == 'bundle' ? 'mb-58' : ''}`}>
                                        <div>
                                            <span className="card-price manrope f-26 black-085 w-700 a-baseline">
                                                {plan.price}
                                                <span className="annual-period manrope f-14 w-400 black-085 lh-22">{plan.price_time}</span>
                                            </span>
                                            <span className={`monthly-period manrope f-14 w-400 lh-22 mb-0`}>{plan.price_details}</span>
                                        </div>
                                        {!['enterprise', 'free_trial_ai'].includes(plan.package_type) && plan.type == 'bundle' &&
                                            <div className="justify-in-end">
                                                <div className="manrope f-10 lh-22 black-085 w-500 mr-8">QTY</div>
                                                <InputNumber
                                                    onKeyDown={(e) => {
                                                        if ((["-", ".", " "].includes(e.key)) || (/[a-zA-Z\s]/.test(e.key) && !allowedKeys.includes(e.key))) {
                                                            e.preventDefault();
                                                        }
                                                    }}
                                                    min={plan.min_quantity}
                                                    value={quantity[plan.package_type] || plan.min_quantity}
                                                    onChange={(value) => handleQuantityChange(value, plan.package_type, plan.credit_value)}
                                                    className="manrope f-14 lh-22 black-085 w-400 width-64" />
                                            </div>}
                                    </div>}

                                {plan.discount_statement != "" ? (
                                    <div className="discount-wrapper">
                                        <TagFilled className="discount-icon" />
                                        <span className="discount manrope f-12 w-500">{annual ? plan.discount_statement : plan.discount_statement_monthly}</span>
                                    </div>
                                ) : ''}
                                {plan.switch_to_subscription != "" ? (
                                    <div className="switch-to-subscription-wrapper mb-24 mt-8">
                                        <a onClick={() => setSelectedPlan("subscriptions")}
                                            className="manrope lh-20 w-500 f-12 w-500 blue">{plan.switch_to_subscription}</a>
                                    </div>
                                ) : ''}
                                <div className="pdr-16">
                                    <Button
                                        className={`${['free_trial_ai'].includes(plan.package_type) ? 'free-trial-button' : ''} card-button manrope f-16 w-600 lh-24`}
                                        block
                                        onClick={() => {
                                            if (['enterprise'].includes(plan.package_type))
                                                window.open(`${ENVIRONMENT.CALENDLY_LINK}`, "_blank")
                                            else if (['free_trial_ai'].includes(plan.package_type))
                                                window.open(`${ENVIRONMENT.FREE_TRIAL_LINK}`, "_blank")
                                            else
                                                window.open(`${ENVIRONMENT.PORTAL_BASE_URL}/register?redirectURL=${encodeURIComponent(`/select-subscription?plan=${annual && plan.type === 'subscription' ? 'annual_' + plan.package_type : plan.package_type}&plan_type=${plan.type}${plan.type === 'bundle' ? `&quantity=${quantity[plan.package_type] || plan.min_quantity}` : ''}&utm_source=${utm_source}`)}`, "_blank")
                                        }}>
                                        {plan.button_text} {credits[plan.package_type] ? ` ${credits[plan.package_type]} credits` : ''}
                                    </Button>
                                </div>

                                <div className="justify-in-center mt-8 pdr-16">
                                    {plan.name != 'Free Trial' && (
                                        plan.credits != "" && plan.type == 'subscription' ?
                                        <div className="manrope f-12 lh-20 w-400 black-085 text-center">{annual ? plan.credits : plan.credits_monthly}</div>
                                        : plan.package_type !== 'enterprise' ? <div className="manrope f-12 lh-20 w-400 black-085 text-center">{`All ${plan.credit_value * (quantity[plan.package_type] || plan.min_quantity)} credits available at once. ${plan.credit_value} credits per image. Unlimited 1K generations.`}</div> : plan.credits
                                    )}
                                </div>
                            </div>
                        </Card>
                    </div>
                ))}
            </div>

            <div className="table-body">
                {basicFeatures.map((row, index) => (
                    <div key={index} className={`table-row ${selectedPlan == 'bundles' ? `bundles` : ''} ${index == 0 ? 'top-left' : ''}`}>
                        <div className="manrope f-14 lh-22 w-700 black-085 text-left feature-name">{row.feature}</div>
                        <div className="manrope f-14 lh-22 w-500 black-085 text-center justify-in-center plan-value">{renderValue(row.free)}</div>
                        <div className={`manrope f-14 lh-22 w-500 black-085 text-center justify-in-center plan-value ${selectedPlan == 'bundles' ? 'blue-border' : ''}`}>
                            {row.feature === "4K images" && selectedPlan === 'bundles' ? renderValue(quantity['basic_ai'] || 5) : renderValue(row.starter)}
                        </div>
                        <div className={`manrope f-14 lh-22 w-500 black-085 text-center justify-in-center plan-value ${selectedPlan == 'subscriptions' ? 'blue-border' : ''}`}>
                            {row.feature === "4K images" && selectedPlan === 'bundles' ? renderValue(quantity['studio_bundle'] || 45) : renderValue(row.growth)}
                        </div>
                        {selectedPlan == 'subscriptions' && <div className="manrope f-14 lh-22 w-500 black-085 text-center justify-in-center plan-value">{renderValue(row.pro)}</div>}
                        <div className="manrope f-14 lh-22 w-500 black-085 text-center justify-in-center plan-value">{renderValue(row.enterprise)}</div>
                    </div>
                ))}
            </div>

            <div className="separator-bar">
                <div><img src={'/ai_creator/ai-star-white.svg'} /></div>
                <div className="manrope f-14 lh-22 w-700 white ml-8">Plus, these advanced editing tools, features, and 3D services</div>
            </div>

            <div className="table-body advanced-features">
                {plusFeatures.map((row, index) => (
                    <div key={index} className={`table-row ${selectedPlan == 'bundles' ? `bundles` : ''} ${index == plusFeatures.length - 1 ? 'border-bottom-radius' : ''}`}>
                        <div className="manrope f-14 lh-22 w-700 black-085 text-left feature-name">{row.feature}</div>
                        <div className={`manrope f-14 lh-22 w-500 black-085 text-center justify-in-center plan-value`}>{renderValue(row.free)}</div>
                        <div className={`manrope f-14 lh-22 w-500 black-085 text-center justify-in-center plan-value ${selectedPlan == 'bundles' ? 'blue-border' : ''} ${selectedPlan == 'bundles' && index == plusFeatures.length - 1 ? 'blue-border-bottom' : ''}`}>{renderValue(row.starter)}</div>
                        <div className={`manrope f-14 lh-22 w-500 black-085 text-center justify-in-center plan-value ${selectedPlan == 'subscriptions' ? 'blue-border' : ''} ${selectedPlan == 'subscriptions' && index == plusFeatures.length - 1 ? 'blue-border-bottom' : ''}`}>{renderValue(row.growth)}</div>
                        {selectedPlan == 'subscriptions' && <div className="manrope f-14 lh-22 w-500 black-085 text-center justify-in-center plan-value">{renderValue(row.pro)}</div>}
                        <div className="manrope f-14 lh-22 w-500 black-085 text-center justify-in-center plan-value">{renderValue(row.enterprise)}</div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default FeatureComparisonTable;
